export const env = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
  REFETCH_TIME: Number(process.env.REACT_APP_REFETCH_TIME) || 8000,
  AUCTION_REFETCH_TIME: Number(process.env.REACT_APP_AUCTION_REFETCH_TIME) || 8000,
};
